import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Correction du problème d'icône par défaut de Leaflet avec Webpack
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

const markerIcon = new L.Icon({
  iconUrl,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const cities = [
  { name: 'Aubignan', position: [44.1167, 5.0167] },
  { name: 'Varennes-sur-Seine', position: [48.3736, 2.5231] },
  { name: 'Montauban', position: [44.0172, 1.3544] },
  { name: 'Bougival', position: [48.8714, 2.1392] },
  { name: 'Rabastens', position: [43.822, 1.726] },
  { name: "L'Isle-Jourdain", position: [43.6136, 1.0808] },
  { name: 'Fécamp', position: [49.7556, 0.3808] },
  { name: 'Mauguio', position: [43.6154, 4.0102] },
  { name: 'Caluire-et-Cuire', position: [45.7968, 4.8424] },
];

const FranceMap: React.FC = () => {
  return (
    <div className="w-full md:h-96 h-72 rounded-lg overflow-hidden border border-gray-200 shadow-sm">
      <MapContainer
        center={[46.603354, 1.888334]} // Centre de la France
        zoom={5}
        scrollWheelZoom={false}
        className="w-full h-full"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
        />
        {cities.map((city) => (
          <Marker key={city.name} position={city.position as [number, number]} icon={markerIcon}>
            <Popup>{city.name}</Popup>
            <Tooltip>{city.name}</Tooltip>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default FranceMap; 